import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import {useTranslation} from "react-i18next";
import * as React from "react";
import Button from "@mui/material/Button";

import { ApiContext } from "../../../App";


export default function CreateNewFacility() {

    const { t } = useTranslation();

    const [name, setName] = React.useState("");

    const { facilityApi } = React.useContext(ApiContext)

    const handleSubmit = () => {

        if (window.confirm(`Are you sure you want to create a new facility named ${name}`)){

            facilityApi.create(
                {name: name},
                (data) => {
                    window.alert("Success. Please update page.")
                },
                (data) => {
                    window.alert("Failed to create new facility.")
                }
            )

        }

    }

    return <Stack direction="row" spacing={2}>
        <TextField
            label={t("Name")}
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setName(e.target.value)}
        >
            {name}
        </TextField>
        <Button onClick={handleSubmit}>
            {t("Submit")}
        </Button>
    </Stack>

};